import { AWPrdUserAttributes, PrdUserAttributeType } from '@blk/awt-userpreference';
import { userPreferenceApi } from './Base';

const path = '/v1/prd-user-attributes';

export function getAllPrdUserAttributes() {
  return userPreferenceApi.get<AWPrdUserAttributes>(path);
}
export function postPrdUserAttributes(newUserAttributes: AWPrdUserAttributes) {
  return userPreferenceApi.post<AWPrdUserAttributes>(path, newUserAttributes);
}
export function patchPrdUserAttributes(
  newUserAttributes: Partial<AWPrdUserAttributes>,
  userAttributeType: PrdUserAttributeType
) {
  return userPreferenceApi.patch<AWPrdUserAttributes>(path, newUserAttributes, {
    params: {
      userAttributeType,
    },
  });
}
